import { sponsoredNewsletterAds } from '../../mocks/sponsoredContent';

export default function NewsletterSponsorBanner() {
  // Get the most recent newsletter sponsor
  const currentSponsor = sponsoredNewsletterAds[0];

  if (!currentSponsor) return null;

  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-200 rounded-xl p-6 mb-8">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-3">
            <span className="px-3 py-1 bg-amber-500 text-white text-xs font-bold rounded-full flex items-center gap-1">
              <i className="ri-vip-crown-fill"></i>
              NEWSLETTER SPONSOR
            </span>
            <span className="text-xs text-gray-500">Week of {currentSponsor.weekOf}</span>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {currentSponsor.headline}
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            {currentSponsor.description}
          </p>
          <a
            href={currentSponsor.ctaLink}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="inline-flex items-center gap-2 px-6 py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            {currentSponsor.ctaText}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="hidden md:block">
          <img
            src={currentSponsor.logo}
            alt={`${currentSponsor.businessName} logo`}
            className="w-48 h-24 object-contain"
          />
        </div>
      </div>
      <div className="pt-4 border-t border-amber-200">
        <p className="text-xs text-gray-500 text-center">
          This is a paid advertisement. <a href="/advertise" className="text-amber-600 hover:underline cursor-pointer">Learn about sponsorship opportunities</a>
        </p>
      </div>
    </div>
  );
}